export const ACCORDION = {
    PARENT_ACCORDION: "parent-accordion",
    CHILD_ACCORDION: "child-accordion",
    PARENT_SUMMARY: "parent-accordion-summary",
    CHILD_SUMMARY: "child-accoridon-summary",
};
